import { Axios } from 'utils'
import { ListResponseType } from 'services/types'
import {
  TBakersRecommendation,
  TUpdateRecommendation,
} from 'types/models/BakersRecommendations'

export const useBakersRecommendationService = () => {
  const getBakersRecommendationListByDeliveryId = async (
    deliveryId: number
  ) => {
    try {
      const response = await Axios.get<ListResponseType<TBakersRecommendation>>(
        `/baker/recommendations/${deliveryId}/list`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateRecommendationByGuid = async (
    guid: string,
    insightInstance: TUpdateRecommendation
  ) => {
    try {
      const response = await Axios.put<ListResponseType<TBakersRecommendation>>(
        `/baker/recommendations/${guid}/update`,
        insightInstance
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getBakersRecommendationListByDeliveryId,
    updateRecommendationByGuid,
  }
}
